import {TextEncoder} from "encoding";
import moment from 	"moment";
import sleep from "sleep";
import Device from "../device.js";


function hexToRgb(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
}

class Module extends Device {
  constructor(serialPort) {
    super(serialPort);

    this.id = "Illumination module";
    this.status = "uninitialized";        
    this.serialPort = serialPort;

    jfermi.RM_illumination_setRGB = this.setRGB.bind(this);
  }
  async initialize() {
    try {            
      await this.serialPort.open({
        baudRate: 9600,
        dataBits: 8,
        parity: "none",
        stopBits: 1    
      });      
      
      await this.setRGB(null, "#000000");

      this.usbProductName = (await this.serialPort.getInfo()).usbProductName;
	  this.usbSerialNumber = (await this.serialPort.getInfo()).usbSerialNumber;  
      this.name = "illumination";
      
      this.status = "OK";      
    } catch(e) {
      this.status = "Failed";
      throw e;
    }
  }
  async update() {
    try {              
      this.status = "Ok";
    } catch(e) {
      this.status = "Failed";
      throw e;
    }      
  }
  /* 
    fermentation: details of the currently running fermentation paramters
    devices: parameters of each connected devices
  */
  async control(fermentation, devices) {
    if (!fermentation.rgb)
      return;
    
    var sunrise = new moment.utc(fermentation.sunrise, 'YYYY-MM-DDTHH:mm:ss.SSS[Z]');
    var sunset = new moment.utc(fermentation.sunset, 'YYYY-MM-DDTHH:mm:ss.SSS[Z]');
    var now = (new moment()).hour()*60+(new moment()).minutes();
    var on = sunrise.hour()*60+sunrise.minutes();
    var off = sunset.hour()*60+sunset.minutes();
        
    if (on<=now && now<off)
      await this.setRGB(null, fermentation.rgb||"#000000");
    else
      await this.setRGB(null, "#000000");
  }
  async setRGB(request, rgb) {
    this.value = rgb;
    this.rgb = rgb;
    var rgb = hexToRgb(this.rgb);

    /*
    TODO: bug, cannot sent as one string to the peripheral
    const encoder = new TextEncoder();
    const writer = this.serialPort.writable.getWriter();
    await writer.write(encoder.encode(`${red}R${green}G${blue}B`).buffer);
    writer.releaseLock();    
    */
    
    await this.setRed(request, rgb.r);
    await sleep(100);
    await this.setGreen(request, rgb.g);
    await sleep(100);
    await this.setBlue(request, rgb.b);
  }
  async setRed(request, red) {
    this.red = red;

    const encoder = new TextEncoder();
    const writer = this.serialPort.writable.getWriter();
    await writer.write(encoder.encode(`${red}R`).buffer);
    writer.releaseLock();    
  }
  async setGreen(request, green) {
    this.green = green;

    const encoder = new TextEncoder();
    const writer = this.serialPort.writable.getWriter();
    await writer.write(encoder.encode(`${green}G`).buffer);
    writer.releaseLock();    
  }
  async setBlue(request, blue) {
    this.blue = blue;

    const encoder = new TextEncoder();
    const writer = this.serialPort.writable.getWriter();
    await writer.write(encoder.encode(`${blue}B`).buffer);
    writer.releaseLock();    
  }  
  toJSON() {
    return({
      id: this.id,
      usbProductName: this.usbProductName,
      usbSerialNumber: this.usbSerialNumber,      
      status: this.status,
      rgb: this.rgb,
      value: this.value
    });
  }
}

export default Module;